import React, { Component } from 'react'
import { connect } from 'react-redux'
import { find, remove } from 'lodash'
import styled, { css, injectGlobal } from 'styled-components'
import { rgba } from 'polished'

import { postData } from '../../api'

// import axios from 'axios'
// import { SERVER_URL } from '../../constants'

import { updateSettings } from '../../settings'
import { fetchFavourites, getFavourites, updateFavourites } from '../../modules/Favourites/redux'

import { media, breakpoints } from '../../styles/utils';
import { green, greenSecondary } from '../../styles/colors';
import { hoverState, padding } from '../../styles/global';

import SaveIconBlack from 'svg-react-loader?name=Icon!../../assets/icons/save-black.svg';
import SaveIconWhite from 'svg-react-loader?name=Icon!../../assets/icons/save-white.svg';

import RemoveIconBlack from 'svg-react-loader?name=Icon!../../assets/icons/remove-black.svg';
import RemoveIconWhite from 'svg-react-loader?name=Icon!../../assets/icons/remove-white.svg';

const testArray = [2155]

class Save extends Component {

    static defaultProps = {
        saveLabel: 'Save image to favourites',
        removeLabel: 'Remove image from favourites'
    }

    state = {
        saved: false
    }

    componentDidMount = () => {
        this.isSaved();
        this.props.fetchFavourites();
    }
    
    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.favourites !== this.props.favourites) {
            this.isSaved();
        }
    }
    
    isSaved = (params) => {
        const { type, id, favourites } = this.props;

        // To do: Retrieve list of current saved ids for type and compare to ID passed

        let idArray;

        if (type == 'document') {
            idArray = favourites.documents;
        }

        if (type == 'imageReference') {
            idArray = favourites.imageReferences;
        }

        if (type == 'image') {
            idArray = favourites.images;
        }

        const saved = idArray.includes(id);

        if (this.state.saved !== saved) {
            this.setState({
                saved: saved
            }) 
        }
    }
    
    handleSave = () => {
        const { type, id, favourites, updateFavourites } = this.props;
        const { saved } = this.state;

        //console.log(`Saving: ${type} ${id}`)

        let newFavourites = Object.assign({}, favourites)
        
        if (type == 'document') {
            if (saved) {
                remove(newFavourites.documents, item => item == id)
            } else {            
                newFavourites.documents.push(id)
            }
        }

        if (type == 'imageReference') {
            if (saved) {
                remove(newFavourites.imageReferences, item => item == id)
            } else {
                newFavourites.imageReferences.push(id)
            }
        }

        if (type == 'image') {
            if (saved) {
                remove(newFavourites.images, item => item == id)
            } else {
                newFavourites.images.push(id)
            }
        }

        //console.log(newFavourites)
        updateFavourites(newFavourites)
    }

    render() {
        const { saved } = this.state;
        const { saveLabel, removeLabel, white } = this.props;

        const SaveIcon = white ? SaveIconWhite : SaveIconBlack;
        const RemoveIcon = white ? RemoveIconWhite : RemoveIconBlack;

        return (
            <Container
                {...this.props}
                onClick={this.handleSave}
            >
                <SaveToggle
                    saved={saved}
                >
                    { saved ? <RemoveIcon/> : <SaveIcon/>}                
                </SaveToggle>

                {saved ? removeLabel : saveLabel}
            </Container>
        )
    }
}

const Container = styled.div`
    overflow: hidden;
    flex: 1;
    display: flex;
    align-items: center;
    ${hoverState};
    cursor: pointer;
    user-select: none;
    height: 23px;

    ${props => {
        if (props.white) return css`
            color: white;
        `
    }}

    ${props => {
        if (props.large) return css`
            @media only screen and (max-width: ${breakpoints.desktop}) and (min-width: ${breakpoints.phone})  {
                font-size: 24px;

                ${SaveToggle} {
                    margin-right: 35px;
                    
                    > * {
                        width: 27px;
                        height: 28px;
                    }
                } 
            }
           
        `
    }}
`

const SaveToggle = styled.div`
    margin-right: 12px;
    transform: translateY(3px);


    ${props => {
        if (props.saved) return css`
           transform: translateY(-4px);
        `
    }}
`

const mapDispatchToProps = dispatch => ({
    fetchFavourites() {
        dispatch(fetchFavourites())
    },
    updateFavourites(favourites) {
        dispatch(updateFavourites(favourites))
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    favourites: getFavourites(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Save);


// WEBPACK FOOTER //
// ./client/components/Save/Save.js